{
  "header": {
    "id": "ID",
    "firstname": "Vorname",
    "lastname": "Nachname",
    "profile": "Profil",
    "profiles": "Profile",
    "email": "E-Mail-Adresse",
    "description": "Beschreibung",
    "sector": "Sektor",
    "sectors": "Sektoren",
    "group": "Gruppe",
    "groups": "Gruppen",
    "user": "Benutzer",
    "users": "Benutzer",
    "application": "Anwendung",
    "applications": "Anwendungen",
    "equipment": "Gerät",
    "equipments": "Geräte",
    "label": "Name",
    "nbUsers": "Anzahl der Benutzer",
    "userGroup": "Gruppe",
    "userGroups": "Gruppen",
    "device": "Gerät",
    "devices": "Geräte"
  }
}
